/* Карточки, плашки, состояния и мелкая типографика */

.card {
  background: var(--mnk-surface);
  border: 1px solid var(--mnk-border);
  border-radius: var(--mnk-radius-lg);
  padding: var(--mnk-space-5);
  box-shadow: var(--mnk-shadow-sm);
}

.cardHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--mnk-space-3);
  margin-bottom: var(--mnk-space-4);
}

.cardTitle {
  font-size: var(--mnk-text-lg);
  font-weight: 700;
  margin: 0;
}

.cardSubtitle {
  color: var(--mnk-text-muted);
  font-size: var(--mnk-text-sm);
  margin: var(--mnk-space-1) 0 0;
}

.flat {
  box-shadow: none;
  background: var(--mnk-bg-elevated);
}

.stat {
  display: flex;
  flex-direction: column;
  gap: var(--mnk-space-1);
  padding: var(--mnk-space-4);
  background: var(--mnk-surface);
  border: 1px solid var(--mnk-border);
  border-radius: var(--mnk-radius-md);
  min-width: 0;
}

.statLabel {
  font-size: var(--mnk-text-xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--mnk-text-faint);
}

.statValue {
  font-size: var(--mnk-text-xl);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  line-height: 1.1;
}

.statHint {
  font-size: var(--mnk-text-xs);
  color: var(--mnk-text-muted);
}

.trendUp {
  color: var(--mnk-success);
}

.trendDown {
  color: var(--mnk-danger);
}

.grid {
  display: grid;
  gap: var(--mnk-space-4);
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}

.badge {
  display: inline-flex;
  align-items: center;
  gap: var(--mnk-space-1);
  padding: 2px var(--mnk-space-2);
  border-radius: var(--mnk-radius-pill);
  font-size: var(--mnk-text-xs);
  font-weight: 600;
  background: var(--mnk-accent-soft);
  color: var(--mnk-accent);
  white-space: nowrap;
}

.badgeNeutral {
  background: var(--mnk-surface-hover);
  color: var(--mnk-text-muted);
}

.badgeSuccess {
  background: color-mix(in srgb, var(--mnk-success) 18%, transparent);
  color: var(--mnk-success);
}

.badgeWarning {
  background: color-mix(in srgb, var(--mnk-warning) 18%, transparent);
  color: var(--mnk-warning);
}

.badgeDanger {
  background: color-mix(in srgb, var(--mnk-danger) 18%, transparent);
  color: var(--mnk-danger);
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  background: var(--mnk-surface-hover);
  display: inline-grid;
  place-content: center;
  font-weight: 700;
  font-size: var(--mnk-text-sm);
  color: var(--mnk-text-muted);
  flex: none;
  overflow: hidden;
}

.progress {
  height: 8px;
  border-radius: var(--mnk-radius-pill);
  background: var(--mnk-bg-sunken);
  overflow: hidden;
}

.progressBar {
  height: 100%;
  background: var(--mnk-accent);
  border-radius: inherit;
  transition: width var(--mnk-duration-base) var(--mnk-ease);
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--mnk-space-3);
  padding: var(--mnk-space-7) var(--mnk-space-4);
  text-align: center;
  color: var(--mnk-text-muted);
}

.emptyTitle {
  font-weight: 700;
  color: var(--mnk-text);
}

.skeleton {
  background: linear-gradient(
    90deg,
    var(--mnk-surface) 25%,
    var(--mnk-surface-hover) 37%,
    var(--mnk-surface) 63%
  );
  background-size: 400% 100%;
  animation: mnk-shimmer 1.4s ease infinite;
  border-radius: var(--mnk-radius-sm);
}

@keyframes mnk-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

.breadcrumbs {
  display: flex;
  align-items: center;
  gap: var(--mnk-space-2);
  font-size: var(--mnk-text-sm);
  color: var(--mnk-text-muted);
  flex-wrap: wrap;
}

.breadcrumbSep {
  color: var(--mnk-text-faint);
}

.pageHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--mnk-space-4);
  margin-bottom: var(--mnk-space-5);
  flex-wrap: wrap;
}

.pageTitle {
  font-size: var(--mnk-text-2xl);
  font-weight: 700;
  margin: 0;
}

.pageDescription {
  color: var(--mnk-text-muted);
  margin: var(--mnk-space-1) 0 0;
}

.toolbar {
  display: flex;
  gap: var(--mnk-space-3);
  align-items: center;
  flex-wrap: wrap;
}
